var AnalyticsProvider;
(function (AnalyticsProvider) {
    AnalyticsProvider["GOOGLE"] = "google";
})(AnalyticsProvider || (AnalyticsProvider = {}));
export { AnalyticsProvider, };
//# sourceMappingURL=analytics-constants.js.map